import { render, staticRenderFns } from "./pyh.vue?vue&type=template&id=3550069a&scoped=true&"
import script from "./pyh.vue?vue&type=script&lang=js&"
export * from "./pyh.vue?vue&type=script&lang=js&"
import style0 from "./pyh.vue?vue&type=style&index=0&id=3550069a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3550069a",
  null
  
)

export default component.exports